import React, { Ref, useState, forwardRef } from "react";

import "./Input.scss";
import {classNames} from "primereact/utils";

interface IProps {
  label?: string;
  type: "text" | "password";
  placeholder?: string;
  small?: boolean;
  responsive?: boolean;
}

const Input = React.forwardRef(
  (
    { label, type, placeholder, small, responsive, ...inputProps }: IProps,
    ref: Ref<HTMLInputElement> | undefined
  ) => {
    const [visible, setVisible] = useState<boolean>(false);

    return (
      <div className="form-input">
          {label && <label>{label}</label>}
        <div className="form-input-field">
          {type === "password" && !responsive && (
            <button
                type={"button"}
              className={`${visible ? "closed" : ""}`}
              onClick={() => setVisible(!visible)}
            ></button>
          )}
          <input
            ref={ref}
            className={classNames({
              small: small,
              responsive: responsive
            })}
            type={visible ? "text" : type}
            placeholder={placeholder}
            {...inputProps}
          />
        </div>
      </div>
    );
  }
);

Input.displayName = "Input"; // Add this line

export default Input;
